// Zamiast apiHelper, importujemy surowego axiosa
import axios from 'axios';

// Pobieramy bazowy URL z zmiennych środowiskowych
const API_SOURCE = process.env.REACT_APP_API_SOURCE;
// Definiujemy pełny adres endpointu czatu
const CHAT_ENDPOINT = `${API_SOURCE}chat/`;

/**
 * Mały helper do pobierania konfiguracji z tokenem autoryzacyjnym.
 * apiHelper robił to automatycznie, tutaj musimy zrobić to ręcznie.
 */
const getAuthConfig = () => {
  const token = localStorage.getItem("token");
  const config = {
    headers: {
      'Content-Type': 'application/json',
    }
  };

  if (token) {
    config.headers['Authorization'] = `Token ${token}`;
  }
  return config;
};


/**
 * @typedef {object} ChatMessagePart
 * @property {string} text
 */

/**
 * @typedef {object} ChatMessage
 * @property {'user' | 'model'} role
 * @property {ChatMessagePart[]} parts
 */

/**
 * Rozpoczyna nową sesję czatu (przez backend DRF).
 * Używa teraz surowego 'axios' bez globalnego interceptora (spinnera).
 *
 * @param {string} problemQuestion
 * @param {string|null} userAnswer
 * @param {string|null} correctAnswer
 * @param {number} points
 * @returns {Promise<{updatedHistory: ChatMessage[]}>}
 */
export const startChatAndGenerateSolution = async (
  problemQuestion,
  userAnswer = null,
  correctAnswer = null,
  points = 1,
  problemId
) => {
  if (!problemQuestion) throw new Error("Treść pytania jest wymagana.");

  const payload = {
    problemData: {
      id:problemId,
      question: problemQuestion,
      userAnswer: userAnswer,
      correctAnswer: correctAnswer,
      points: points,
      
    },
    chatHistory: [], // Na start wysyłamy pustą historię
  };

  // Pobieramy konfigurację z tokenem
  const config = getAuthConfig();

  try {
    // Używamy 'axios.post' z pełnym adresem URL i ręczną konfiguracją
    const response = await axios.post(CHAT_ENDPOINT, payload, config);
    return response.data;
  } catch (error) {
    console.error("Błąd API (startChat backend):", error.response?.data || error.message);
    
    const errorText = error.response?.data?.updatedHistory
      ? error.response.data.updatedHistory.find(m => m.role === 'model')?.parts[0]?.text
      : "Błąd serwera podczas rozpoczynania czatu.";
      
    throw new Error(errorText || "Nieznany błąd serwera.");
  }
};

/**
 * Kontynuuje istniejący czat (przez backend DRF).
 * Używa teraz surowego 'axios' bez globalnego interceptora (spinnera).
 *
 * @param {ChatMessage[]} currentHistory // Historia *przed* nową wiadomością
 * @param {string} userMessageText // Nowa wiadomość
 * @param {number} points
 * @returns {Promise<{updatedHistory: ChatMessage[]}>}
 */
export const continueChat = async (
  currentHistory,
  userMessageText,
  points = 1,
  problemId
) => {
  if (!userMessageText) throw new Error("Pusta wiadomość.");

  const payload = {
    chatHistory: currentHistory, // Przekaż historię
    newMessage: userMessageText, // Przekaż nową wiadomość osobno
    problemData: {
      id: problemId,
        points: points // Przekaż punkty, aby backend mógł wybrać model
    }
  };

  // Pobieramy konfigurację z tokenem
  const config = getAuthConfig();

  try {
    // Używamy 'axios.post' z pełnym adresem URL i ręczną konfiguracją
    const response = await axios.post(CHAT_ENDPOINT, payload, config);
    return response.data; // Oczekujemy { updatedHistory: [...] }
  } catch (error) {
    console.error("Błąd API (continueChat backend):", error.response?.data || error.message);

    const errorText = error.response?.data?.updatedHistory
      ? error.response.data.updatedHistory.find(m => m.role === 'model')?.parts[0]?.text
      : "Błąd serwera podczas kontynuacji czatu.";

    throw new Error(errorText || "Nieznany błąd serwera.");
  }
};